export function useHeadHtmlAttrs() {
  const { $i18n: { locale } } = useNuxtApp()
  return {
    lang: locale.value,
  }
}
